export interface WebsocketMessageModel {
  version: number;
  event: WebsocketEventType;
  category: string;
  action: WebsocketActionType;
  content: any;
  reference: any;
  timestamp: number;
}
export enum WebsocketEventType {
  COMMUNITY = 'Community',
  TICKET = 'Ticket',
}
export enum WebsocketActionType {
  CREATE = 'Create',
  UPDATE = 'Update',
  PATCH = 'Patch',
  DELETE = 'Delete',
}
